import { render, staticRenderFns } from "./AllShipment.vue?vue&type=template&id=f54e817a&scoped=true"
import script from "./AllShipment.vue?vue&type=script&lang=js"
export * from "./AllShipment.vue?vue&type=script&lang=js"
import style0 from "./AllShipment.vue?vue&type=style&index=0&id=f54e817a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54e817a",
  null
  
)

export default component.exports